/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import Select from '../Primitives/Select';
import { useAllCountries } from '../../context/customerAccount/queries/useAllCountries';
import Input from '../Primitives/Input';

type ProvinceNameInputProps = {
    countryName: string;
    provinceName: string;
    setProvinceName: React.Dispatch<React.SetStateAction<string>>;
    selectFirstOption: string;
    onChange: (provinceName: string) => void;
    errorMessage: string;
    validateValue: (value: string) => void;
    setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ProvinceNameInput: React.FC<ProvinceNameInputProps> = ({
    countryName,
    provinceName,
    setProvinceName,
    selectFirstOption,
    onChange,
    errorMessage,
    validateValue,
    setIsRequired,
}) => {
    const { getRegionsByCountryName } = useAllCountries();

    const [provinceSelectChoices, setProvinceSelectChoices] = useState<any[]>(
        []
    );

    useEffect(() => {
        const provinceSelectChoices =
            getRegionsByCountryName(countryName) ?? [];

        setProvinceSelectChoices(provinceSelectChoices);
        setIsRequired(provinceSelectChoices.length > 0);
        setProvinceName('');
    }, [countryName]);

    return provinceSelectChoices.length > 0 ? (
        <Select
            elements={provinceSelectChoices.map(
                (province: any) => province.name
            )}
            firstOption={selectFirstOption}
            error={errorMessage}
            value={provinceName}
            onChange={(value: string) => {
                onChange(value);
            }}
            validateInput={() => validateValue(countryName)}
        />
    ) : (
        <Input
            type='text'
            value={provinceName}
            onChange={(value) => {
                onChange(value);
            }}
        />
    );
};
